import { PhotoStrip } from './PhotoStrip'

export default PhotoStrip
